import * as constants from "../constants/CONSTANT";
import authApi from "./authApi";

import { getAxios, getAxiosFile, getAxiosMultipart } from "../utils/helper";

const solisPowerApi = {
  // ************************ ACCOUNT ****************************

  //.... Create Account.........
  async createAccount(accounts) {

    console.log("createAccount Call", accounts);
    // Get axios Instance
    const instance = getAxios();
    try {
      // Called the API
      const response = await instance.post(
        `${constants.API_BASE_URL + "/api/accounts/"}`,
        accounts
      );
      // console.log("response", response);
      // If record created
      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      // If some error occurred while calling api request
      // if user is unauthorized
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return { errors: error?.response?.data?.errors };
    }

    return null;
  },

  //.... Fetch All Accounts ..........
  async fetchAccounts() {
    // Get axios Instance
    const instance = getAxios();
    try {
      // Called the API
      const response = await instance.get(
        `${constants.API_BASE_URL + "/api/accounts/"}`
      );

      // console.log("response", response);

      // If records found
      if (response?.data?.length > 0) {
        console.log("data", response?.data);
        return response?.data;
      }
    } catch (error) {
      // If some error occurred while calling api request
      // if user is unauthorized
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return null;
    }

    return null;
  },

  //..... Fetch Account By Id ...........
  async fetchAccountById(id) {
    // Get axios Instance
    const instance = getAxios();
    try {
      // Called the API
      const response = await instance.get(
        `${constants.API_BASE_URL + "/api/accounts/" + id}`
      );

      // If record found
      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      // If some error occurred while calling api request
      // if user is unauthorized
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return null;
    }
    return null;
  },

  // ....Update Account.........
  async saveAccount(account) {
    // Get axios Instance
    const instance = getAxios();
    try {
      // Called the API
      const response = await instance.put(
        `${constants.API_BASE_URL + "/api/accounts/" + account.id}`,
        account
      );

      // If record found
      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      // If some error occurred while calling api request
      // if user is unauthorized
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return { errors: error?.response?.data?.errors };
    }
    return null;
  },

  //...... Delete Account .............................
  async deleteAccounts(id) {
    // Get axios Instance
    const instance = getAxios();
    try {
      // Called the API
      const response = await instance.delete(
        `${constants.API_BASE_URL + "/api/accounts/" + id}`
      );
      // If record deleted successfully
      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      // If some error occurred while calling api request
      // if user is unauthorized
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return null;
    }
    return null;
  },

  // ************************ Enquiry ****************************
  // ..... Create Enquiry(External Enquiry Form).......
  async createEnquiry(enquiry) {
    // Get axios Instance
    const instance = getAxios();
    try {
      // Called the API
      const response = await instance.post(
        `${constants.API_BASE_URL + "/api/leads/enquiry"}`,
        enquiry
      );
      // console.log("response", response);
      // If record created
      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      // If some error occurred while calling api request
      // if user is unauthorized
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return { errors: error?.response?.data?.errors };
    }
    return null;
  },

  // async fetchProducts() {
  //   // For Enquiry Form
  //   // Get axios Instance
  //   const instance = getAxios();
  //   try {
  //     // Called the API
  //     const response = await instance.get(
  //       `${constants.API_BASE_URL + "/api/leads/enquiry/serial/"}`
  //     );

  //     // console.log("response", response);

  //     // If records found
  //     if (response?.data.length > 0) {
  //       // console.log("data", response?.data);
  //       return response?.data;
  //     }
  //   } catch (error) {
  //     // If some error occurred while calling api request
  //     // if user is unauthorized
  //     if (error?.response?.status === 401) {
  //       authApi.logout();
  //     }
  //     console.log(error.response);
  //     return null;
  //   }

  //   return null;
  // },

  async fetchProductsForEnquiry() {
    // For Enquiry Form
    // Get axios Instance
    const instance = getAxios();
    try {
      // Called the API
      const response = await instance.get(
        `${constants.API_BASE_URL + "/api/leads/enquiry/serial/"}`
      );

      // console.log("response", response);

      // If records found
      if (response?.data.length > 0) {
        // console.log("data", response?.data);
        return response?.data;
      }
    } catch (error) {
      // If some error occurred while calling api request
      // if user is unauthorized
      // if (error?.response?.status === 401) {
      //   authApi.logout();
      // }
      console.log(error.response);
      return null;
    }

    return null;
  },

  //Contacts for Enquiry
  async fetchContactsForEnquiry() {
    // For Enquiry Form
    // Get axios Instance
    const instance = getAxios();
    try {
      // Called the API
      const response = await instance.get(
        `${constants.API_BASE_URL + "/api/leads/enquiry/contact/"}`
      );

      // console.log("response", response);

      // If records found
      if (response?.data.length > 0) {
        // console.log("data", response?.data);
        return response?.data;
      }
    } catch (error) {
      // If some error occurred while calling api request
      // if user is unauthorized
      // if (error?.response?.status === 401) {
      //   authApi.logout();
      // }
      console.log(error.response);
      return null;
    }

    return null;
  },

  // ***********************************************************

  // ************************ Contact ****************************
  //.... Create Contact .........
  async createContact(contacts) {
    // Get axios Instance
    const instance = getAxios();
    try {
      // Called the API
      const response = await instance.post(
        `${constants.API_BASE_URL + "/api/contacts/"}`,
        contacts
      );
      // console.log("response", response);
      // If record created
      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      // If some error occurred while calling api request
      // if user is unauthorized
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return { errors: error?.response?.data?.errors };
    }

    return null;
  },

  //.... Fetch All Contact ..........
  async fetchContacts() {
    // Get axios Instance
    const instance = getAxios();
    try {
      // Called the API
      const response = await instance.get(
        `${constants.API_BASE_URL + "/api/contacts/"}`
      );

      // console.log("response", response);

      // If records found
      if (response?.data.length > 0) {
        // console.log("data", response?.data);
        return response?.data;
      }
    } catch (error) {
      // If some error occurred while calling api request
      // if user is unauthorized
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return null;
    }

    return null;
  },

  //..... Fetch Distinct Contact Types (for Lead Source) ...........
  async fetchDistinctContactTypes() {
    const instance = getAxios();
    try {
      const response = await instance.get(
        `${constants.API_BASE_URL + "/api/contacts/distinct-types"}`
      );
      if (response?.data && Array.isArray(response.data)) {
        return response.data;
      }
      return [];
    } catch (error) {
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.error("fetchDistinctContactTypes error:", error?.response);
      return [];
    }
  },

  //..... Fetch Contacts By Type (for Reference By) ...........
  async fetchContactsByType(contactType) {
    if (!contactType || String(contactType).trim() === "") return [];
    const instance = getAxios();
    try {
      const encoded = encodeURIComponent(contactType.trim());
      const response = await instance.get(
        `${constants.API_BASE_URL + "/api/contacts/by-type/" + encoded}`
      );
      if (response?.data && Array.isArray(response.data)) {
        return response.data;
      }
      return [];
    } catch (error) {
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.error("fetchContactsByType error:", error?.response);
      return [];
    }
  },

  //..... Fetch Contact By Id ...........
  async fetchContactById(id) {
    // Get axios Instance
    const instance = getAxios();
    try {
      // Called the API
      const response = await instance.get(
        `${constants.API_BASE_URL + "/api/contacts/" + id}`
      );

      // If record found
      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      // If some error occurred while calling api request
      // if user is unauthorized
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return null;
    }
    return null;
  },

  // ....Update Contact.........
  async saveContact(contacts) {
    // Get axios Instance
    const instance = getAxios();
    try {
      // Called the API
      const response = await instance.put(
        `${constants.API_BASE_URL + "/api/contacts/" + contacts.id}`,
        contacts
      );

      // If record found
      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      // If some error occurred while calling api request
      // if user is unauthorized
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return { errors: error?.response?.data?.errors };
    }
    return null;
  },

  //...... Delete Contact .............................
  async deleteContacts(id) {
    // Get axios Instance
    const instance = getAxios();
    try {
      // Called the API
      const response = await instance.delete(
        `${constants.API_BASE_URL + "/api/contacts/" + id}`
      );
      // If record deleted successfully
      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      // If some error occurred while calling api request
      // if user is unauthorized
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return null;
    }
    return null;
  },

  // ************************ Contact End Here ***********************************

  //..... Create Contact (External Enquiry Form).......
  // async createContactEnquiry(enquiryDetails) {

  //     let response = await fetch(
  //         constants.API_BASE_URL + "/api/contacts/enquiry",
  //         {
  //             method: "post",
  //             mode: "cors",
  //             headers: {
  //                 "Content-Type": "application/json",
  //                 // Authorization: token,
  //             },
  //             body: JSON.stringify(enquiryDetails),
  //         }
  //     );

  //     const result = await response.json();
  //     ////console.log("current record from api  in fetch =>", result);
  //     if (result) {
  //         console.log('Result in fetch =>', result)
  //         return result;
  //     }
  //     return null;
  // },

  // ************************* Leads **********************************
  // API: Create a new lead
  async createLead(lead) {
    const instance = getAxios();
    try {
      const response = await instance.post(
        `${constants.API_BASE_URL + "/api/leads/"}`,
        lead
      );
      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return { errors: error?.response?.data?.errors };
    }
    return null;
  },

  // API: Fetch All leads
  // Modified By Farhan Khan on 16-Feb-2026 (Added server-side pagination for performance - returns { data, total, page, pageSize } when page/pageSize params provided)
  async fetchLeads(filterData) {
    const instance = getAxios();
    try {
      const response = await instance.get(
        `${constants.API_BASE_URL + "/api/leads/"}`,
        { params: filterData }
      );
      if (response?.data != null) {
        if (response.data && typeof response.data === "object" && "data" in response.data) {
          return response.data; // Paginated response: { data, total, page, pageSize }
        }
        if (Array.isArray(response.data) && response.data.length > 0) {
          return response.data;
        }
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return null;
    }
    return null;
  },

  // API: Fetch a Lead by ID
  async fetchLeadById(id) {
    const instance = getAxios();
    try {
      const response = await instance.get(
        `${constants.API_BASE_URL + "/api/leads/" + id}`
      );
      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return null;
    }
    return null;
  },

  // Fetch Leads By DateRange
  async fetchLeadsByDateRange(fromDate, toDate) {
    const instance = getAxios();
    const queryParams = new URLSearchParams({ from: fromDate, to: toDate });
    // console.log('queryParams', queryParams.toString());
    try {
      const response = await instance.get(
        `${constants.API_BASE_URL
        }/api/leads/date_range/?${queryParams?.toString()}`
      );
      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return null;
    }
    return null;
  },

  // API: Fetch leads For offer Creation
  async fetchLeadsForOffer() {
    const instance = getAxios();
    try {
      const response = await instance.get(
        `${constants.API_BASE_URL + "/api/leads/offer"}`
      );
      if (response?.data.length > 0) {
        return response?.data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return null;
    }
    return null;
  },

  // API: Check if lead exists by phone (for New Lead pre-check modal)
  async checkLeadPhone(phone) {
    const instance = getAxios();
    try {
      const phoneStr = phone != null ? String(phone).replace(/\D/g, "").slice(-10) : "";
      if (!phoneStr || phoneStr.length !== 10) return { exists: false, lead: null };
      const response = await instance.get(
        `${constants.API_BASE_URL}/api/leads/check-phone`,
        { params: { phone: phoneStr } }
      );
      if (response?.data) {
        return response.data;
      }
    } catch (error) {
      if (error?.response?.status === 401) { }
      if (error?.response?.status === 403) await authApi.refreshToken();
      console.log("checkLeadPhone error", error?.response);
      return { exists: false, lead: null };
    }
    return { exists: false, lead: null };
  },

  // API: Update an Existing Lead
  async saveLead(lead) {
    const instance = getAxios();
    try {
      const response = await instance.put(
        `${constants.API_BASE_URL + "/api/leads/" + lead.id}`,
        lead
      );
      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return { errors: error?.response?.data?.errors };
    }
    return null;
  },

  // API: Delete a Lead by ID
  async deleteLead(id) {
    const instance = getAxios();
    try {
      const response = await instance.delete(
        `${constants.API_BASE_URL + "/api/leads/" + id}`
      );
      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log('Error on delete lead', error.response);
      return { errors: error?.response?.data?.message };
    }
    return null;
  },

  // Lead Project Line Items (Project Information & Address)
  async saveLeadProjectLineItems(leadId, items) {
    const instance = getAxios();
    try {
      const response = await instance.post(
        `${constants.API_BASE_URL + "/api/lead-project-line-items/save"}`,
        { lead_id: leadId, items: items || [] }
      );
      return response?.data;
    } catch (error) {
      if (error?.response?.status === 401) { }
      if (error?.response?.status === 403) await authApi.refreshToken();
      console.log(error?.response);
      return { errors: error?.response?.data?.errors };
    }
  },
  async fetchLeadProjectLineItems(leadId) {
    const instance = getAxios();
    try {
      const response = await instance.get(
        `${constants.API_BASE_URL + "/api/lead-project-line-items/lead/" + leadId}`
      );
      return Array.isArray(response?.data) ? response.data : [];
    } catch (error) {
      if (error?.response?.status === 401) { }
      if (error?.response?.status === 403) await authApi.refreshToken();
      return [];
    }
  },
  // Added By Farhan Khan on 25-Feb-2026 (Logic) - Fetch all projects for Project List page
  async fetchProjects(filterData) {
    const instance = getAxios();
    try {
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/lead-project-line-items/list"}`,
        { params: filterData }
      );
      if (data && Array.isArray(data)) {
        return data;
      }
      return [];
    } catch (error) {
      if (error?.response?.status === 401) { }
      if (error?.response?.status === 403) await authApi.refreshToken();
      console.log(error?.response);
      return [];
    }
  },
  async deleteLeadProjectLineItem(id) {
    const instance = getAxios();
    try {
      const response = await instance.delete(
        `${constants.API_BASE_URL + "/api/lead-project-line-items/" + id}`
      );
      return response?.data;
    } catch (error) {
      if (error?.response?.status === 401) { }
      if (error?.response?.status === 403) await authApi.refreshToken();
      return { errors: error?.response?.data?.errors };
    }
  },
  async updateProjectStatus(projectId, project_status) {
    const instance = getAxios();
    try {
      const response = await instance.patch(
        `${constants.API_BASE_URL + "/api/lead-project-line-items/" + projectId + "/status"}`,
        { project_status }
      );
      return response?.data;
    } catch (error) {
      if (error?.response?.status === 401) { }
      if (error?.response?.status === 403) await authApi.refreshToken();
      return { errors: error?.response?.data?.errors };
    }
  },

  // ************************ Leads End Here ***********************************

  // ************************ Users ***********************************
  //..... Fetch Users ........
  async fetchAllTeleCallerUsers() {
    const instance = getAxios();
    try {
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/auth/users/tele/caller"}`
      );

      if (data?.length > 0) {
        return data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return null;
    }

    return null;
  },
  //..... Fetch Users ........
  async fetchUsers() {
    const instance = getAxios();
    try {
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/auth/users"}`
      );

      if (data?.length > 0) {
        return data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return null;
    }

    return null;
  },
  //..... Fetch Users dropdown value........
  async fetchUsersDropdown() {
    const instance = getAxios();
    try {
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/auth/getusersdropdown"}`
      );

      if (data?.length > 0) {
        return data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return null;
    }

    return null;
  },

  //..... Fetch Users ........
  async fetchUsersForListPage() {
    const instance = getAxios();
    try {
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/auth/users/for-list-page"}`
      );

      if (data?.length > 0) {
        return data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return null;
    }

    return null;
  },


  //.................... Fetch Login Users ...................................
  async getLoginUserData() {
    const instance = getAxios();
    try {
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/auth/getuser"}`
      );
      // if (data.status === 401) {
      //   authApi.logout();
      // }
      if (data?.status === 401) {
        // await authApi.logout();
      }
      if (data?.status === 403) {
        await authApi.refreshToken();
      }

      if (data) {
        return data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return { errors: error?.response?.data?.errors };
    }
    return null;
  },

  async createUser(user) {
    const instance = getAxios();
    try {
      const response = await instance.post(
        `${constants.API_BASE_URL + "/api/auth/create_user"}`,
        user
      );
      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return { errors: error?.response?.data?.errors };
    }
    return null;
  },

  //........ Fetch Lead By Id .........
  async fetchUserById(id) {
    const instance = getAxios();
    try {
      const response = await instance.get(
        `${constants.API_BASE_URL + "/api/auth/users/" + id}`
      );
      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return null;
    }
    return null;
  },

  //....... Save Login Users ...................................
  async saveUser(user) {
    const instance = getAxios();
    try {
      const { data } = await instance.put(
        `${constants.API_BASE_URL + "/api/auth/" + user.id}`,
        user
      );

      if (data) {
        return data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return { errors: error?.response?.data?.errors };
    }
    return null;
  },

  //------------- Save Staff Member Profile ---------------------------
  async saveStaffMemberEditProfile(userid, selectedFiles, staffMember) {
    const formData = new FormData();
    formData.append('file', selectedFiles);
    formData.append('staffRecord', staffMember);
    const instance = getAxiosFile();
    try {
      const { data } = instance.put(
        `${constants.API_BASE_URL + "/api/auth/" + userid + "/profile"}`, formData
      );
      if (data) {
        return data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return { errors: error?.response?.data?.errors };
    }
    return null;
  },

  //.................... Update Login Users ...................................
  async updateUser(user) {
    const instance = getAxios();
    try {
      const { data } = await instance.put(
        `${constants.API_BASE_URL + "/api/auth/update-password"}`,
        user
      );
      if (data) {
        return data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return { errors: error?.response?.data?.errors };
    }
    return null;
  },
  // ************************ Users End Here ***********************************

  // ************************ UserTracking ********************************************

  // --create userTracking--
  async createUserTracking(record) {
    const instance = getAxios();
    try {
      const response = await instance.post(
        `${constants.API_BASE_URL + "/api/user_trackings"}`,
        record
      );
      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return { errors: error?.response?.data?.errors };
    }
    return null;
  },

  // update userTracking
  async saveUserTracking(record) {
    const instance = getAxios();
    try {
      // console.log("record", record);
      const { data } = await instance.put(
        `${constants.API_BASE_URL + "/api/user_trackings/" + record.id}`,
        record
      );

      if (data) {
        return data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return { errors: error?.response?.data?.errors };
    }
    return null;
  },

  //..... Fetch UserTrackings ........
  async fetchUserTrackings(filterData) {
    const instance = getAxios();
    try {
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/user_trackings"}`,
        { params: filterData }
      );

      if (data?.length > 0) {
        return data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return null;
    }

    return null;
  },

  //..... Fetch UserTracking By ID ........
  async fetchUserTrackingById(id) {
    const instance = getAxios();
    try {
      const response = await instance.get(
        `${constants.API_BASE_URL + "/api/user_trackings/" + id}`
      );
      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return null;
    }
    return null;
  },

  //..... Fetch UserTracking By ID ........
  async fetchUserTrackingByParentId(id) {
    const instance = getAxios();
    try {
      const response = await instance.get(
        `${constants.API_BASE_URL + "/api/user_trackings/parent/" + id}`
      );
      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return null;
    }
    return null;
  },

  // Fetch UserTracking By DateRange
  async fetchUserTrackingByDateRange(fromDate, toDate) {
    const instance = getAxios();
    const queryParams = new URLSearchParams({ from: fromDate, to: toDate });
    // console.log('queryParams', queryParams.toString());
    try {
      const response = await instance.get(
        `${constants.API_BASE_URL
        }/api/user_trackings/date_range/?${queryParams?.toString()}`
      );
      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return null;
    }
    return null;
  },

  // ---Delete UserTracking By ID
  async deleteUserTrackingById(id) {
    const instance = getAxios();
    try {
      const response = await instance.delete(
        `${constants.API_BASE_URL + "/api/user_trackings/" + id}`
      );
      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return { errors: error?.response?.data?.errors };
    }
    return null;
  },

  // ************************ UserTracking End Here ***********************************

  // *******************************Messages******************************************

  //   //................... Create Messages ................................
  async createMessage(messages) {
    const instance = getAxios();
    try {
      const { data } = await instance.post(
        `${constants.API_BASE_URL + "/api/messages"}`,
        messages
      );

      if (data) {
        return data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return null;
    }

    return null;
  },

  // .......... All Messages .............................
  async fetchMessages(pid) {
    const instance = getAxios();
    const { data } = await instance.get(
      `${constants.API_BASE_URL + "/api/messages/" + pid + "/*"}`
    );
    if (data) {
      return data;
    }
    return null;
  },

  // fetch Unread message
  async fetchUnreadMessages() {
    const instance = getAxios();
    try {
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/messages/unread"}`
      );

      if (data?.length > 0) {
        return data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return null;
    }

    return null;
  },

  async deleteMessage(id) {
    const instance = getAxios();
    try {
      const response = await instance.delete(
        `${constants.API_BASE_URL + "/api/messages/" + id}`
      );
      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return { errors: error?.response?.data?.errors };
    }
    return null;
  },

  async markReadMessage(notificationId) {
    const instance = getAxios();
    try {
      const { data } = await instance.post(
        `${constants.API_BASE_URL + "/api/messages/markread/" + notificationId}`
      );

      if (data?.length > 0) {
        return data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return null;
    }

    return null;
  },

  async deletePushNotification(notificationId) {
    const instance = getAxios();
    try {
      const { data } = await instance.delete(
        `${constants.API_BASE_URL + "/api/messages/markdelete/" + notificationId
        }`
      );

      if (data?.length > 0) {
        return data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return null;
    }

    return null;
  },

  // ************************ Messages End Here ***********************************

  // *******************************Tasks******************************************
  // --create task--
  async createTask(record) {
    const instance = getAxios();
    try {
      const response = await instance.post(
        `${constants.API_BASE_URL + "/api/tasks"}`,
        record
      );
      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return { errors: error?.response?.data?.errors };
    }
    return null;
  },

  // update task
  async saveTask(record) {
    const instance = getAxios();
    try {
      // console.log("record", record);
      const { data } = await instance.put(
        `${constants.API_BASE_URL + "/api/tasks/" + record.id}`,
        record
      );

      if (data) {
        return data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return { errors: error?.response?.data?.errors };
    }
    return null;
  },

  //..... Fetch tasks ........
  async fetchTasks() {
    const instance = getAxios();
    try {
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/tasks"}`
      );

      if (data?.length > 0) {
        return data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return null;
    }

    return null;
  },

  //..... Fetch Task By ID ........
  async fetchTaskById(id) {
    const instance = getAxios();
    try {
      const response = await instance.get(
        `${constants.API_BASE_URL + "/api/tasks/" + id}`
      );
      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return null;
    }
    return null;
  },

  //..... Fetch Tasks By Parent ID ........
  async fetchTasksByParentId(id) {
    const instance = getAxios();
    try {
      const response = await instance.get(
        `${constants.API_BASE_URL + "/api/tasks/parent/" + id}`
      );
      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return null;
    }
    return null;
  },

  // ---Delete Task By ID
  async deleteTaskById(id) {
    const instance = getAxios();
    try {
      const response = await instance.delete(
        `${constants.API_BASE_URL + "/api/tasks/" + id}`
      );
      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return { errors: error?.response?.data?.errors };
    }
    return null;
  },
  // ************************ Tasks End Here ***********************************

  // ************************ Offer ********************************************

  // --create Offer--
  async createOffer(record) {
    const instance = getAxios();
    try {
      const response = await instance.post(
        `${constants.API_BASE_URL + "/api/offers"}`,
        record
      );
      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return { errors: error?.response?.data?.errors };
    }
    return null;
  },

  // update Offer
  async saveOffer(record) {
    const instance = getAxios();
    try {
      // console.log("record", record);
      const { data } = await instance.put(
        `${constants.API_BASE_URL + "/api/offers/" + record.id}`,
        record
      );

      if (data) {
        return data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return { errors: error?.response?.data?.errors };
    }
    return null;
  },

  //..... Fetch Offers ........
  async fetchOffers(filterData) {
    const instance = getAxios();
    try {
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/offers"}`,
        { params: filterData }
      );

      if (data?.length > 0) {
        return data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return null;
    }

    return null;
  },

  //..... Fetch Offer By ID ........
  async fetchOfferById(id) {
    const instance = getAxios();
    try {
      const response = await instance.get(
        `${constants.API_BASE_URL + "/api/offers/" + id}`
      );
      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return null;
    }
    return null;
  },

  //..... Fetch Offers By Lead ID ........
  async fetchOffersByLeadId(id) {
    const instance = getAxios();
    try {
      const response = await instance.get(
        `${constants.API_BASE_URL}/api/offers/lead/${id}`
      );
      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return null;
    }
    return null;
  },

  // Fetch Offers By DateRange
  async fetchOffersByDateRange(fromDate, toDate) {
    const instance = getAxios();
    const queryParams = new URLSearchParams({ from: fromDate, to: toDate });
    // console.log('queryParams', queryParams.toString());
    try {
      const response = await instance.get(
        `${constants.API_BASE_URL
        }/api/offers/date_range/?${queryParams?.toString()}`
      );
      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return null;
    }
    return null;
  },

  // API: Fetch Offers For order Creation : fetch all Offers which pass the criteria for order
  async fetchOffersForOrder() {
    const instance = getAxios();
    try {
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/offers/order"}`
      );

      if (data?.length > 0) {
        return data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return null;
    }

    return null;
  },

  // API: Fetch Offers For handover Creation : fetch all Offers which pass the criteria for handover
  async fetchOffersForHandover() {
    const instance = getAxios();
    try {
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/offers/handover"}`
      );

      if (data?.length > 0) {
        return data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return null;
    }

    return null;
  },

  // ---Delete Offer By ID
  async deleteOfferById(id) {
    const instance = getAxios();
    try {
      const response = await instance.delete(
        `${constants.API_BASE_URL + "/api/offers/" + id}`
      );
      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return { errors: error?.response?.data?.errors };
    }
    return null;
  },

  // ************************ Offer End Here ***********************************

  // ************************ Order ********************************************

  // --create Order--
  async createOrder(record) {
    const instance = getAxios();
    try {
      const response = await instance.post(
        `${constants.API_BASE_URL + "/api/orders"}`,
        record
      );
      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return { errors: error?.response?.data?.errors };
    }
    return null;
  },

  // update Order
  async saveOrder(record) {
    const instance = getAxios();
    try {
      // console.log('record', record);
      const { data } = await instance.put(
        `${constants.API_BASE_URL + "/api/orders/" + record.id}`,
        record
      );

      if (data) {
        return data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return { errors: error?.response?.data?.errors };
    }
    return null;
  },

  //..... Fetch Orders ........
  async fetchOrders(filterData) {
    const instance = getAxios();
    try {
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/orders"}`,
        {
          params: filterData,
        }
      );

      if (data?.length > 0) {
        return data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return null;
    }

    return null;
  },

  //..... Fetch Orders ........
  async fetchOrdersForOrderAMC() {
    const instance = getAxios();
    try {
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/orders/order_amc/"}`
      );

      if (data?.length > 0) {
        return data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return null;
    }

    return null;
  },

  //..... Fetch Orders ........
  async fetchOrdersForWarranty() {
    const instance = getAxios();
    try {
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/orders/warranty/"}`
      );

      if (data?.length > 0) {
        return data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return null;
    }

    return null;
  },

  //..... Fetch Order By ID ........
  async fetchOrderById(id) {
    const instance = getAxios();
    try {
      const response = await instance.get(
        `${constants.API_BASE_URL + "/api/orders/" + id}`
      );
      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return null;
    }
    return null;
  },

  //..... Fetch Orders By Lead ID ........
  async fetchOrdersByLeadId(id) {
    const instance = getAxios();
    try {
      const response = await instance.get(
        `${constants.API_BASE_URL}/api/orders/lead/${id}`
      );
      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return null;
    }
    return null;
  },

  //..... Fetch Orders By Lead ID ........
  async fetchOrdersByOfferId(id) {
    const instance = getAxios();
    try {
      const response = await instance.get(
        `${constants.API_BASE_URL}/api/orders/offer/${id}`
      );
      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return null;
    }
    return null;
  },

  // Fetch Orders By DateRange
  async fetchOrdersByDateRange(fromDate, toDate) {
    const instance = getAxios();
    const queryParams = new URLSearchParams({ from: fromDate, to: toDate });
    // console.log('queryParams', queryParams.toString());
    try {
      const response = await instance.get(
        `${constants.API_BASE_URL
        }/api/orders/date_range/?${queryParams?.toString()}`
      );
      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return null;
    }
    return null;
  },

  // ---Delete Order By ID
  async deleteOrderById(id) {
    console.log('order delete id', id);
    const instance = getAxios();
    try {
      const response = await instance.delete(
        `${constants.API_BASE_URL + "/api/orders/" + id}`
      );
      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return { errors: error?.response?.data?.errors };
    }
    return null;
  },

  // ************************ Order End Here ***********************************

  // ************************ OrderAmc ********************************************

  // --create OrderAmc--
  async createOrderAmc(record) {
    const instance = getAxios();
    try {
      const response = await instance.post(
        `${constants.API_BASE_URL + "/api/order_amcs"}`,
        record
      );
      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return { errors: error?.response?.data?.errors };
    }
    return null;
  },

  // update OrderAmc
  async saveOrderAmc(record) {
    const instance = getAxios();
    try {
      // console.log('record', record);
      const { data } = await instance.put(
        `${constants.API_BASE_URL + "/api/order_amcs/" + record.id}`,
        record
      );

      if (data) {
        return data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return { errors: error?.response?.data?.errors };
    }
    return null;
  },

  //..... Fetch OrderAMCs ........
  async fetchOrderAmcs(filterData) {
    const instance = getAxios();
    try {
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/order_amcs"}`,
        { params: filterData }
      );

      if (data?.length > 0) {
        return data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return null;
    }

    return null;
  },

  //..... Fetch OrderAmc By ID ........
  async fetchOrderAmcById(id) {
    const instance = getAxios();
    try {
      const response = await instance.get(
        `${constants.API_BASE_URL + "/api/order_amcs/" + id}`
      );
      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return null;
    }
    return null;
  },

  // Fetch OrderAMCs By DateRange
  async fetchOrderAmcsByDateRange(fromDate, toDate) {
    const instance = getAxios();
    const queryParams = new URLSearchParams({ from: fromDate, to: toDate });
    // console.log('queryParams', queryParams.toString());
    try {
      const response = await instance.get(
        `${constants.API_BASE_URL
        }/api/order_amcs/date_range/?${queryParams?.toString()}`
      );
      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return null;
    }
    return null;
  },

  //..... Fetch OrderAMCs By order ID ........
  async fetchOrderAmcsByOrderId(id) {
    const instance = getAxios();
    try {
      const response = await instance.get(
        `${constants.API_BASE_URL + "/api/order_amcs/order/" + id}`
      );
      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return null;
    }
    return null;
  },

  // ---Delete OrderAmc By ID
  async deleteOrderAmcById(id) {
    const instance = getAxios();
    try {
      const response = await instance.delete(
        `${constants.API_BASE_URL + "/api/order_amcs/" + id}`
      );
      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return { errors: error?.response?.data?.errors };
    }
    return null;
  },

  // ................... Fetch All Payments (Order Wise) ................................
  async fetchOrdeAMCWisePayments(id) {
    // Get axios instance
    const instance = getAxios();
    try {
      // Call the API
      const response = await instance.get(
        `${constants.API_BASE_URL}/api/order_amcs/payments/${id}`
      );
      // if (response?.data?.status === 401) {
      //   authApi.logout();
      // }
      if (response?.data?.status === 401) {
        // await authApi.logout();
      }
      if (response?.data?.status === 403) {
        await authApi.refreshToken();
      }

      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      console.error("Error fetching project payments:", error.response);
    }
    return null;
  },

  //..... Fetch Orders AMC By Lead ID ........
  async fetchOrderAMCsByLeadId(id) {
    const instance = getAxios();
    try {
      const response = await instance.get(
        `${constants.API_BASE_URL}/api/order_amcs/lead/${id}`
      );
      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return null;
    }
    return null;
  },

  // ************************ OrderAmc End Here ***********************************

  // // *******************************Product Starts here**********************************

  //   //................... Create Product ................................
  async createProduct(products) {
    const instance = getAxios();
    const { data } = await instance.post(
      `${constants.API_BASE_URL + "/api/products/"}`,
      products
    );

    if (data) {
      return data;
    }
    return null;
  },

  async saveProduct(products) {
    const instance = getAxios();
    const { data } = await instance.put(
      `${constants.API_BASE_URL + "/api/products/" + products.id}`,
      products
    );
    if (data) {
      return data;
    }
    return null;
  },

  //................... Fetch All Product ................................
  async fetchProducts() {
    const instance = getAxios();
    const { data } = await instance.get(
      `${constants.API_BASE_URL + "/api/products/"}`
    );

    // if (data.status === 401) {
    //   authApi.logout();
    // }

    if (data?.status === 401) {
      // await authApi.logout();
    }
    if (data?.status === 403) {
      await authApi.refreshToken();
    }

    if (data.length > 0) {
      return data;
    }
    return null;
  },

  //................... Fetch All Product With PriceBook ................................
  async fetchProductPriceBooks() {
    const instance = getAxios();
    const { data } = await instance.get(
      `${constants.API_BASE_URL + "/api/products/productpricebooks"}`
    );

    // if (data.status === 401) {
    //   authApi.logout();
    // }
    if (data?.status === 401) {
      // await authApi.logout();
    }
    if (data?.status === 403) {
      await authApi.refreshToken();
    }

    if (data.length > 0) {
      return data;
    }
    return null;
  },

  //.............. Fetch Product By Id .............................
  async fetchProductById(id) {
    const instance = getAxios();
    const { data } = await instance.get(
      `${constants.API_BASE_URL + "/api/products/" + id}`
    );
    // if (data.status === 401) {
    //   authApi.logout();
    // }
    if (data?.status === 401) {
      // await authApi.logout();
    }
    if (data?.status === 403) {
      await authApi.refreshToken();
    }
    if (data) {
      return data;
    }
    return null;
  },

  //.............. Fetch Product By Project Id .............................
  async fetchProductByProjectId(id) {
    const instance = getAxios();
    const { data } = await instance.get(
      `${constants.API_BASE_URL + "/api/products/projects/" + id}`
    );
    // if (data.status === 401) {
    //   authApi.logout();
    // }

    if (data?.status === 401) {
      // await authApi.logout();
    }
    if (data?.status === 403) {
      await authApi.refreshToken();
    }

    if (data) {
      return data;
    }
    return null;
  },

  // .......... Delete Product   .............................
  async deleteProduct(id) {
    const instance = getAxios();
    const { data } = await instance.delete(
      `${constants.API_BASE_URL + "/api/products/" + id}`
    );
    if (data) {
      return data;
    }
    return null;
  },

  //.... Fetch Active Brands for Product dropdown .......... (Added By Farhan Khan Khan on 24-Dec-2025)
  async fetchActiveBrands() {
    const instance = getAxios();
    const { data } = await instance.get(
      `${constants.API_BASE_URL + "/api/products/brands/active"}`
    );

    if (data?.status === 401) {
      // await authApi.logout();
    }

    if (data) {
      return data;
    }
    return null;
  },

  // ************************ BOM CATEGORY ****************************
  // Added By Farhan Khan Khan on 24-Dec-2025

  //.... Create BOM Category.........
  async createBomCategory(bomCategories) {
    const instance = getAxios();
    const { data } = await instance.post(
      `${constants.API_BASE_URL + "/api/bom_categories/"}`,
      bomCategories
    );

    if (data) {
      return data;
    }
    return null;
  },

  //.... Save BOM Category (Update).........
  async saveBomCategory(bomCategories) {
    const instance = getAxios();
    const { data } = await instance.put(
      `${constants.API_BASE_URL + "/api/bom_categories/" + bomCategories.id}`,
      bomCategories
    );
    if (data) {
      return data;
    }
    return null;
  },

  //.... Fetch All BOM Categories  ..........
  async fetchBomCategories() {
    const instance = getAxios();
    const { data } = await instance.get(
      `${constants.API_BASE_URL + "/api/bom_categories/"}`
    );

    if (data?.status === 401) {
      // await authApi.logout();
    }

    if (data) {
      return data;
    }
    return null;
  },

  //.... Fetch Active BOM Categories  ..........
  async fetchActiveBomCategories() {
    const instance = getAxios();
    const { data } = await instance.get(
      `${constants.API_BASE_URL + "/api/bom_categories/active/list"}`
    );

    if (data?.status === 401) {
      // await authApi.logout();
    }

    if (data) {
      return data;
    }
    return null;
  },

  //.... Fetch BOM Category By Id  ..........
  async fetchBomCategoryById(id) {
    const instance = getAxios();
    const { data } = await instance.get(
      `${constants.API_BASE_URL + "/api/bom_categories/" + id}`
    );
    if (data?.status === 401) {
      // await authApi.logout();
    }
    if (data) {
      return data;
    }
    return null;
  },

  //.... Fetch BOM Category With Items  .......... (Added By Farhan Khan Khan on 24-Dec-2025)
  async fetchBomCategoryWithItems(id) {
    const instance = getAxios();
    const { data } = await instance.get(
      `${constants.API_BASE_URL + "/api/bom_categories/" + id + "?with_items=true"}`
    );
    if (data?.status === 401) {
      // await authApi.logout();
    }
    if (data) {
      return data;
    }
    return null;
  },

  // .......... Delete BOM Category   .............................
  async deleteBomCategory(id) {
    const instance = getAxios();
    const { data } = await instance.delete(
      `${constants.API_BASE_URL + "/api/bom_categories/" + id}`
    );
    if (data) {
      return data;
    }
    return null;
  },

  // ************************ BOM MASTER ITEM ****************************
  // Added By Farhan Khan Khan on 24-Dec-2025

  //.... Create BOM Master Item.........
  async createBomMasterItem(bomMasterItems) {
    const instance = getAxios();
    const { data } = await instance.post(
      `${constants.API_BASE_URL + "/api/bom_master_items/"}`,
      bomMasterItems
    );

    if (data) {
      return data;
    }
    return null;
  },

  //.... Save BOM Master Item (Update).........
  async saveBomMasterItem(bomMasterItems) {
    const instance = getAxios();
    const { data } = await instance.put(
      `${constants.API_BASE_URL + "/api/bom_master_items/" + bomMasterItems.id}`,
      bomMasterItems
    );
    if (data) {
      return data;
    }
    return null;
  },

  //.... Fetch All BOM Master Items  ..........
  async fetchBomMasterItems() {
    const instance = getAxios();
    const { data } = await instance.get(
      `${constants.API_BASE_URL + "/api/bom_master_items/"}`
    );

    if (data?.status === 401) {
      // await authApi.logout();
    }

    if (data) {
      return data;
    }
    return null;
  },

  //.... Fetch BOM Master Item By Id  ..........
  async fetchBomMasterItemById(id) {
    const instance = getAxios();
    const { data } = await instance.get(
      `${constants.API_BASE_URL + "/api/bom_master_items/" + id}`
    );
    if (data?.status === 401) {
      // await authApi.logout();
    }
    if (data) {
      return data;
    }
    return null;
  },

  //.... Fetch Material Products (for BOM Master Item)  ..........
  async fetchMaterialProducts() {
    const instance = getAxios();
    const { data } = await instance.get(
      `${constants.API_BASE_URL + "/api/bom_master_items/products/material/active"}`
    );

    if (data?.status === 401) {
      // await authApi.logout();
    }

    if (data) {
      return data;
    }
    return null;
  },

  //.... Fetch Product Details for Auto-fill  ..........
  async fetchProductDetailsForBom(productId) {
    const instance = getAxios();
    const { data } = await instance.get(
      `${constants.API_BASE_URL + "/api/bom_master_items/product/" + productId + "/details"}`
    );

    if (data?.status === 401) {
      // await authApi.logout();
    }

    if (data) {
      return data;
    }
    return null;
  },

  // .......... Delete BOM Master Item   .............................
  async deleteBomMasterItem(id) {
    const instance = getAxios();
    const { data } = await instance.delete(
      `${constants.API_BASE_URL + "/api/bom_master_items/" + id}`
    );
    if (data) {
      return data;
    }
    return null;
  },

  //.... Bulk Create BOM Master Items  .......... (Added By Farhan Khan Khan on 24-Dec-2025)
  async bulkCreateBomMasterItems(items) {
    const instance = getAxios();
    const { data } = await instance.post(
      `${constants.API_BASE_URL + "/api/bom_master_items/bulk"}`,
      items
    );
    if (data?.status === 401) {
      // await authApi.logout();
    }
    if (data) {
      return data;
    }
    return null;
  },

  // .......... Mounting Structure APIs - Created By System on 06-Feb-2026 .............................
  // Bulk Create Mounting Structures
  async bulkCreateMountingStructures(items) {
    const instance = getAxios();
    const { data } = await instance.post(
      `${constants.API_BASE_URL + "/api/mounting_structures/bulk"}`,
      items
    );
    if (data?.status === 401) {
      // await authApi.logout();
    }
    if (data) {
      return data;
    }
    return null;
  },

  // Fetch Mounting Structures by Category ID
  async fetchMountingStructuresByCategory(categoryId) {
    const instance = getAxios();
    const { data } = await instance.get(
      `${constants.API_BASE_URL + "/api/mounting_structures/category/" + categoryId}`
    );
    if (data) {
      return data;
    }
    return null;
  },

  // Delete Mounting Structures by Category ID
  async deleteMountingStructuresByCategory(categoryId) {
    const instance = getAxios();
    const { data } = await instance.delete(
      `${constants.API_BASE_URL + "/api/mounting_structures/category/" + categoryId}`
    );
    if (data) {
      return data;
    }
    return null;
  },

  // Bulk Create Mounting Structure Parts
  async bulkCreateMountingStructureParts(parts) {
    const instance = getAxios();
    const { data } = await instance.post(
      `${constants.API_BASE_URL + "/api/mounting_structure_parts/bulk"}`,
      parts
    );
    if (data?.status === 401) {
      // await authApi.logout();
    }
    if (data) {
      return data;
    }
    return null;
  },

  // Fetch Mounting Structure Parts by Structure ID
  async fetchMountingStructurePartsByStructure(structureId) {
    const instance = getAxios();
    const { data } = await instance.get(
      `${constants.API_BASE_URL + "/api/mounting_structure_parts/structure/" + structureId}`
    );
    if (data) {
      return data;
    }
    return null;
  },

  // Delete Mounting Structure Parts by Structure ID
  async deleteMountingStructurePartsByStructure(structureId) {
    const instance = getAxios();
    const { data } = await instance.delete(
      `${constants.API_BASE_URL + "/api/mounting_structure_parts/structure/" + structureId}`
    );
    if (data) {
      return data;
    }
    return null;
  },

  // ************************ QUOTATION ****************************
  // Added By Farhan Khan Khan on 24-Dec-2025

  //.... Create Quotation.........
  async createQuotation(quotation) {
    const instance = getAxios();
    const { data } = await instance.post(
      `${constants.API_BASE_URL + "/api/quotations"}`,
      quotation
    );

    if (data?.status === 401) {
      // await authApi.logout();
    }

    if (data) {
      return data;
    }
    return null;
  },

  //.... Save Quotation (Update).........
  async saveQuotation(quotation) {
    const instance = getAxios();
    const { data } = await instance.put(
      `${constants.API_BASE_URL + "/api/quotations/" + quotation.id}`,
      quotation
    );
    if (data?.status === 401) {
      // await authApi.logout();
    }
    if (data) {
      return data;
    }
    return null;
  },

  //.... Fetch Quotations.........
  async fetchQuotations() {
    const instance = getAxios();
    const { data } = await instance.get(
      `${constants.API_BASE_URL + "/api/quotations"}`
    );

    if (data?.status === 401) {
      // await authApi.logout();
    }

    if (data) {
      return data;
    }
    return null;
  },

  //.... Fetch Quotation By Id  ..........
  async fetchQuotationById(id) {
    const instance = getAxios();
    const { data } = await instance.get(
      `${constants.API_BASE_URL + "/api/quotations/" + id + "?with_items=true"}`
    );
    if (data?.status === 401) {
      // await authApi.logout();
    }
    if (data) {
      return data;
    }
    return null;
  },

  // .......... Delete Quotation   .............................
  async deleteQuotation(id) {
    const instance = getAxios();
    const { data } = await instance.delete(
      `${constants.API_BASE_URL + "/api/quotations/" + id}`
    );
    if (data) {
      return data;
    }
    return null;
  },

  //.... Fetch Non-Material Products  .......... (Added By Farhan Khan Khan on 24-Dec-2025)
  async fetchNonMaterialProducts() {
    const instance = getAxios();
    const { data } = await instance.get(
      `${constants.API_BASE_URL + "/api/products/type/non_material"}`
    );

    if (data?.status === 401) {
      // await authApi.logout();
    }

    if (data) {
      return data;
    }
    return null;
  },

  //.... Fetch Leads for Quotation  .......... (Added By Farhan Khan Khan on 24-Dec-2025)
  async fetchLeadsForQuotation() {
    const instance = getAxios();
    try {
      const response = await instance.get(
        `${constants.API_BASE_URL + "/api/leads/quotation"}`
      );
      if (response?.data && response.data.length > 0) {
        return response.data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return null;
    }
    return null;
  },

  // ************************ QUOTATION BOM ITEMS ****************************
  // Added By Farhan Khan Khan on 24-Dec-2025

  //.... Fetch BOM Master Items by Category  .......... 
  async fetchBomMasterItemsByCategory(categoryId) {
    const instance = getAxios();
    try {
      const response = await instance.get(
        `${constants.API_BASE_URL + "/api/bom_master_items/category/" + categoryId}`
      );
      if (response?.data) {
        return response.data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return { errors: error?.response?.data?.errors };
    }
    return null;
  },

  //.... Fetch Quotation BOM Items by Quotation ID  .......... 
  async fetchQuotationBomItems(quotationId) {
    const instance = getAxios();
    try {
      const response = await instance.get(
        `${constants.API_BASE_URL + "/api/quotation_bom_items/quotation/" + quotationId}`
      );
      if (response?.data) {
        return response.data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return { errors: error?.response?.data?.errors };
    }
    return null;
  },

  // BOM Line Items – View Only (Quotation Detail)
  // Added By Farhan Khan Khan on 24-Dec-2025
  //.... Fetch Quotation BOM Items by Quotation ID (via quotation route)  .......... 
  async fetchQuotationBomItemsByQuotationId(quotationId) {
    const instance = getAxios();
    try {
      const response = await instance.get(
        `${constants.API_BASE_URL + "/api/quotations/" + quotationId + "/bom-items"}`
      );
      if (response?.data) {
        return response.data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return [];
    }
    return [];
  },

  // PDF Generation – Fetch quotation data for PDF
  // Added By Farhan Khan Khan on 24-Dec-2025
  //.... Fetch Quotation Data for PDF Generation  .......... 
  async fetchQuotationDataForPDF(quotationId) {
    const instance = getAxios();
    try {
      const response = await instance.get(
        `${constants.API_BASE_URL + "/api/quotations/" + quotationId + "/pdf"}`
      );
      if (response?.data) {
        return response.data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return null;
    }
    return null;
  },

  //.... Bulk Create Quotation BOM Items  .......... 
  async bulkCreateQuotationBomItems(items) {
    const instance = getAxios();
    try {
      const { data } = await instance.post(
        `${constants.API_BASE_URL + "/api/quotation_bom_items/bulk"}`,
        items
      );
      if (data?.status === 401) {
        // await authApi.logout();
      }
      if (data) {
        return data;
      }
    } catch (error) {
      console.log(error);
      return { errors: error?.response?.data?.errors };
    }
    return null;
  },

  // Added By Farhan Khan Khan on 24-Dec-2025
  //.... Save Quotation Line Items (Separate API)  .......... 
  async saveQuotationLineItems(quotationId, items) {
    const instance = getAxios();
    try {
      const { data } = await instance.post(
        `${constants.API_BASE_URL + "/api/quotation-line-items/save"}`,
        {
          quotation_id: quotationId,
          items: items
        }
      );
      if (data?.status === 401) {
        // await authApi.logout();
      }
      if (data) {
        return data;
      }
    } catch (error) {
      console.log(error);
      return { errors: error?.response?.data?.errors || error.message };
    }
    return null;
  },

  // Added By Farhan Khan Khan on 24-Dec-2025
  //.... Save Quotation BOM Items (Separate API)  .......... 
  // Created on 2026-02-07 by Farhan Khan - Quotation Mounting Structures APIs
  // Save quotation mounting structures with parts
  async saveQuotationMountingStructures(quotationId, mountingStructures) {
    const instance = getAxios();
    const { data } = await instance.post(
      `${constants.API_BASE_URL + "/api/quotation_mounting_structures/save"}`,
      {
        quotation_id: quotationId,
        mounting_structures: mountingStructures
      }
    );
    if (data?.status === 401) {
      // await authApi.logout();
    }
    if (data) {
      return data;
    }
    return null;
  },

  // Fetch quotation mounting structures by quotation ID
  async fetchQuotationMountingStructures(quotationId) {
    const instance = getAxios();
    const { data } = await instance.get(
      `${constants.API_BASE_URL + "/api/quotation_mounting_structures/quotation/" + quotationId}`
    );
    if (data?.status === 401) {
      // await authApi.logout();
    }
    if (data) {
      return data;
    }
    return null;
  },

  async saveQuotationBomItems(quotationId, quotationBomItems) {
    const instance = getAxios();
    try {
      const { data } = await instance.post(
        `${constants.API_BASE_URL + "/api/quotation-bom-items/save"}`,
        {
          quotation_id: quotationId,
          quotation_bom_items: quotationBomItems
        }
      );
      if (data?.status === 401) {
        // await authApi.logout();
      }
      if (data) {
        return data;
      }
    } catch (error) {
      console.log(error);
      return { errors: error?.response?.data?.errors || error.message };
    }
    return null;
  },

  // ************************ BRAND ****************************
  // Added By Farhan Khan Khan on 24-Dec-2025

  //.... Create Brand.........
  async createBrand(brands) {
    const instance = getAxios();
    const { data } = await instance.post(
      `${constants.API_BASE_URL + "/api/brands/"}`,
      brands
    );

    if (data) {
      return data;
    }
    return null;
  },

  //.... Save Brand (Update).........
  async saveBrand(brands) {
    const instance = getAxios();
    const { data } = await instance.put(
      `${constants.API_BASE_URL + "/api/brands/" + brands.id}`,
      brands
    );
    if (data) {
      return data;
    }
    return null;
  },

  //.... Fetch All Brands  ..........
  async fetchBrands() {
    const instance = getAxios();
    const { data } = await instance.get(
      `${constants.API_BASE_URL + "/api/brands/"}`
    );

    if (data?.status === 401) {
      // await authApi.logout();
    }

    if (data) {
      return data;
    }
    return null;
  },

  //.... Fetch Brand By Id  ..........
  async fetchBrandById(id) {
    const instance = getAxios();
    const { data } = await instance.get(
      `${constants.API_BASE_URL + "/api/brands/" + id}`
    );
    if (data?.status === 401) {
      // await authApi.logout();
    }
    if (data) {
      return data;
    }
    return null;
  },

  // .......... Delete Brand   .............................
  async deleteBrand(id) {
    const instance = getAxios();
    const { data } = await instance.delete(
      `${constants.API_BASE_URL + "/api/brands/" + id}`
    );
    if (data) {
      return data;
    }
    return null;
  },

  //   //************************ files ***********************************//

  async createFile(pid, formData) {
    // console.log("FormData", formData);
    const token = localStorage.getItem("token");

    try {
      let response = await fetch(constants.API_BASE_URL + "/api/files/" + pid, {
        method: "POST",
        mode: "cors",
        headers: {
          Authorization: token,
        },
        body: formData,
      });

      if (response.ok) {
        return await response.json();
      } else {
        // Handle different response statuses
        const errorData = await response.json();
        throw new Error(`Error ${response.status}: ${errorData.message}`);
      }
    } catch (error) {
      console.error("File upload failed", error);
      throw error;
    }
  },

  async saveFiles(file) {
    // console.log("File on Update", file);
    const token = localStorage.getItem("token");
    let response = await fetch(
      constants.API_BASE_URL + "/api/files/" + file.id,
      {
        method: "PUT",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify(file),
      }
    );

    return await response.json();
  },

  //   //************Download File ************ */
  async downloadFiles(fileid, foldername) {
    ////console.log("save", fileid);
    const token = localStorage.getItem("token");
    let response = await fetch(
      `${constants.API_BASE_URL}/api/files/${fileid}/${foldername}/download`,

      {
        method: "GET",
        //mode: "cors",

        headers: {
          Authorization: token,
        },
      }
    );
    const fileBody = await response.blob();
    return fileBody;
  },

  //--------------- Fetch All Files Folder wise & All ----------------------------------------
  async fetchFiles(parentId, folderName) {
    // console.log("--foldername in APi Side--", folderName);
    const token = localStorage.getItem("token");
    let response = await fetch(
      constants.API_BASE_URL +
      "/api/files/" +
      parentId +
      "/" +
      folderName +
      "/all",
      {
        method: "GET",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }
    );

    const result = await response.json();
    ////console.log('result', result);
    ////console.log(response)
    if (result.length > 0) {
      return result;
    }
    return null;
  },

  async fetchPrimaryImages(parentId, folderName) {
    console.log("--foldername in APi Side--", parentId);
    const token = localStorage.getItem("token");
    let response = await fetch(
      constants.API_BASE_URL + "/api/files/primaryphotos/" + parentId,
      {
        method: "GET",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }
    );

    const result = await response.json();
    ////console.log('result', result);
    ////console.log(response)
    if (result) {
      return result;
    }
    return null;
  },

  //eslint-disable-next-line
  async deleteFile(id) {
    const token = localStorage.getItem("token");
    let response = await fetch(constants.API_BASE_URL + "/api/files/" + id, {
      method: "DELETE",
      mode: "cors",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    });
    return await response.json();
  },

  // ************************ HandOver ****************************
  //.... Create HandOver .........
  async createHandoverRecord(handover) {
    // Get axios Instance
    const instance = getAxios();
    try {
      // Called the API
      const response = await instance.post(
        `${constants.API_BASE_URL + "/api/handover/"}`,
        handover
      );
      // console.log("response", response);
      // If record created
      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      // If some error occurred while calling api request
      // if user is unauthorized
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return { errors: error?.response?.data?.errors };
    }

    return null;
  },

  // ....Update HandOver.........
  async saveHandOverRecord(handover) {
    // Get axios Instance
    const instance = getAxios();
    try {
      // Called the API
      const response = await instance.put(
        `${constants.API_BASE_URL + "/api/handover/" + handover.id}`,
        handover
      );

      // If record found
      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      // If some error occurred while calling api request
      // if user is unauthorized
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return { errors: error?.response?.data?.errors };
    }
    return null;
  },

  //.... Fetch All Handover ..........
  async fetchHandoverRecords() {
    // Get axios Instance
    const instance = getAxios();
    try {
      // Called the API
      const response = await instance.get(
        `${constants.API_BASE_URL + "/api/handover/"}`
      );

      // console.log("response", response);

      // If records found
      if (response?.data.length > 0) {
        // console.log("data", response?.data);
        return response?.data;
      }
    } catch (error) {
      // If some error occurred while calling api request
      // if user is unauthorized
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return null;
    }

    return null;
  },

  //..... Fetch HandOver By Id ...........
  async fetchHandoverRecordById(id) {
    // Get axios Instance
    const instance = getAxios();
    try {
      // Called the API
      const response = await instance.get(
        `${constants.API_BASE_URL + "/api/handover/" + id}`
      );

      // If record found
      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      // If some error occurred while calling api request
      // if user is unauthorized
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return null;
    }
    return null;
  },

  // Fetch By DateRange
  async fetchHandoverByDateRange(fromDate, toDate) {
    const instance = getAxios();
    const queryParams = new URLSearchParams({ from: fromDate, to: toDate });
    // console.log('queryParams', queryParams.toString());
    try {
      const response = await instance.get(
        `${constants.API_BASE_URL
        }/api/handover/date_range/?${queryParams?.toString()}`
      );
      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return null;
    }
    return null;
  },

  //...... Delete HandOver .............................
  async deleteHandoverRecordById(id) {
    // Get axios Instance
    const instance = getAxios();
    try {
      // Called the API
      const response = await instance.delete(
        `${constants.API_BASE_URL + "/api/handover/" + id}`
      );
      // If record deleted successfully
      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      // If some error occurred while calling api request
      // if user is unauthorized
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return null;
    }
    return null;
  },

  //..... Fetch Handover By Parent (Offre) ID ........
  async fetchHandoverByParentId(id) {
    const instance = getAxios();
    try {
      const response = await instance.get(
        `${constants.API_BASE_URL + "/api/handover/parent/" + id}`
      );
      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return null;
    }
    return null;
  },

  //Added By Jaseem
  // --------------------------------- Report ----------------------------------------

  // Fetch Report By DateRange
  async fetchReportByDateRange(report, fromDate, toDate) {
    console.log("fetchReportByDateRange", report);
    const instance = getAxios();
    const queryParams = new URLSearchParams({
      id: report.id,
      api_name: report.apiname,
      from: fromDate,
      to: toDate,
    });
    console.log("queryParams", queryParams.toString());
    try {
      const response = await instance.get(
        `${constants.API_BASE_URL
        }/api/reports/date_range/?${queryParams?.toString()}`
      );
      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return null;
    }
    return null;
  },

  async fetchReports() {
    const instance = getAxios();
    const { data } = await instance.get(
      `${constants.API_BASE_URL + "/api/reports"}`
    );
    // if (data.status === 401) {
    //   authApi.logout();
    // }

    if (data?.status === 401) {
      // await authApi.logout();
    }
    if (data?.status === 403) {
      await authApi.refreshToken();
    }

    if (data.length > 0) {
      return data;
    }
    return null;
  },

  async fetchReportsById(row) {
    const instance = getAxios();
    const { data } = await instance.get(
      `${constants.API_BASE_URL + "/api/reports/" + row.id}`
    );
    // if (data.status === 401) {
    //   authApi.logout();
    // }
    if (data?.status === 401) {
      // await authApi.logout();
    }
    if (data?.status === 403) {
      await authApi.refreshToken();
    }
    if (data) {
      return data;
    }
    return null;
  },

  //Fetch Leads By DateRange
  async fetchLeadsByDateRange(fromDate, toDate) {
    const instance = getAxios();
    const queryParams = new URLSearchParams({ from: fromDate, to: toDate });
    // console.log('queryParams', queryParams.toString());
    try {
      const response = await instance.get(
        `${constants.API_BASE_URL
        }/api/leads/date_range/?${queryParams?.toString()}`
      );
      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return null;
    }
    return null;
  },

  // ************************ Warranty ****************************
  //.... Create Warranty .........
  async createWarranty(warranty) {
    // warranty
    // Get axios Instance
    const instance = getAxios();
    try {
      // Called the API
      const response = await instance.post(
        `${constants.API_BASE_URL + "/api/warraties/"}`,
        warranty
      );
      // console.log("response", response);
      // If record created
      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      // If some error occurred while calling api request
      // if user is unauthorized
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return { errors: error?.response?.data?.errors };
    }

    return null;
  },

  //.... Fetch All Warranty ..........
  async fetchWarranties(filterData) {
    // Get axios Instance
    const instance = getAxios();
    try {
      // Called the API
      const response = await instance.get(
        `${constants.API_BASE_URL + "/api/warraties/"}`,
        {
          params: filterData,
        }
      );

      // console.log("response", response);

      // If records found
      if (response?.data.length > 0) {
        // console.log("data", response?.data);
        return response?.data;
      }
    } catch (error) {
      // If some error occurred while calling api request
      // if user is unauthorized
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return null;
    }

    return null;
  },

  //..... Fetch Warranty By Id ...........
  async fetchWarrantyById(id) {
    // Get axios Instance
    const instance = getAxios();
    try {
      // Called the API
      const response = await instance.get(
        `${constants.API_BASE_URL + "/api/warraties/" + id}`
      );

      // If record found
      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      // If some error occurred while calling api request
      // if user is unauthorized
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return null;
    }
    return null;
  },

  // Fetch Offers By DateRange
  async fetchWarrantyByDateRange(fromDate, toDate) {
    const instance = getAxios();
    const queryParams = new URLSearchParams({ from: fromDate, to: toDate });
    // console.log('queryParams', queryParams.toString());
    try {
      const response = await instance.get(
        `${constants.API_BASE_URL
        }/api/warraties/date_range/?${queryParams?.toString()}`
      );
      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return null;
    }
    return null;
  },

  //..... Fetch Warranty By order Id ...........
  async fetchWarrantyByOrderId(id) {
    // Get axios Instance
    const instance = getAxios();
    try {
      // Called the API
      const response = await instance.get(
        `${constants.API_BASE_URL + "/api/warraties/order/" + id}`
      );

      // If record found
      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      // If some error occurred while calling api request
      // if user is unauthorized
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return null;
    }
    return null;
  },

  // ....Update Warranty.........
  async saveWarranty(warranty) {
    // Get axios Instance
    const instance = getAxios();
    try {
      // Called the API
      const response = await instance.put(
        `${constants.API_BASE_URL + "/api/warraties/" + warranty.id}`,
        warranty
      );

      // If record found
      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      // If some error occurred while calling api request
      // if user is unauthorized
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return { errors: error?.response?.data?.errors };
    }
    return null;
  },

  //...... Delete Warranty .............................
  async deleteWarranty(id) {
    // Get axios Instance
    const instance = getAxios();
    try {
      // Called the API
      const response = await instance.delete(
        `${constants.API_BASE_URL + "/api/warraties/" + id}`
      );
      // If record deleted successfully
      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      // If some error occurred while calling api request
      // if user is unauthorized
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return null;
    }
    return null;
  },

  // --------------------- Home Dashboard API (Common)-----------------------------------
  //................... Fetch All Leads Counts ................................
  async fetchLeadCount(filterDate) {
    const instance = getAxios();
    try {
      let queryParams = null;
      if (filterDate) {
        queryParams = new URLSearchParams({ from: filterDate.fromDate, to: filterDate.toDate });
      }

      const response = await instance.get(
        `${constants.API_BASE_URL}/api/common/leads/total${queryParams ? `?${queryParams?.toString()}` : ''}`
      );

      // if (response.status === 401) {
      //   authApi.logout();
      // }

      if (response?.status === 401) {
        // await authApi.logout();
      }
      if (response?.status === 403) {
        await authApi.refreshToken();
      }

      if (response.data.length > 0) {
        return response.data;
      }
    } catch (error) {
      // If some error occurred while calling api request
      // if user is unauthorized
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return null;
    }
    return null;
  },

  //................... Fetch Site Visits ................................
  async fetchSiteVisits(filterDate) {
    const instance = getAxios();
    try {
      let queryParams = null;
      if (filterDate) {
        queryParams = new URLSearchParams({ from: filterDate.fromDate, to: filterDate.toDate });
      }

      const response = await instance.get(
        `${constants.API_BASE_URL}/api/common/user-trackings/total${queryParams ? `?${queryParams?.toString()}` : ''}`
      );

      // if (response.status === 401) {
      //   authApi.logout();
      // }

      if (response?.status === 401) {
        // await authApi.logout();
      }
      if (response?.status === 403) {
        await authApi.refreshToken();
      }

      if (response.data.length > 0) {
        return response.data;
      }
    } catch (error) {
      // If some error occurred while calling api request
      // if user is unauthorized
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return null;
    }
    return null;
  },

  //................... Fetch All Offer Unit Counts ................................
  async fetchOfferUnitsTotal(filterDate) {
    const instance = getAxios();
    try {
      let queryParams = null;
      if (filterDate) {
        queryParams = new URLSearchParams({ from: filterDate.fromDate, to: filterDate.toDate });
      }
      const response = await instance.get(
        // `${constants.API_BASE_URL + "/api/leads/total"}`
        `${constants.API_BASE_URL}/api/common/offers/total${queryParams ? `?${queryParams?.toString()}` : ''}`
      );

      // if (response.status === 401) {
      //   authApi.logout();
      // }
      if (response?.status === 401) {
        // await authApi.logout();
      }
      if (response?.status === 403) {
        await authApi.refreshToken();
      }

      if (response.data.length > 0) {
        return response.data;
      }
    } catch (error) {
      // If some error occurred while calling api request
      // if user is unauthorized
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return null;
    }
    return null;
  },

  //................... Fetch All AMC Counts ................................
  async fetchAMCTotal(filterDate) {
    const instance = getAxios();
    try {
      let queryParams = null;
      if (filterDate) {
        queryParams = new URLSearchParams({ from: filterDate.fromDate, to: filterDate.toDate });
      }
      const response = await instance.get(
        // `${constants.API_BASE_URL + "/api/leads/total"}`
        `${constants.API_BASE_URL}/api/common/order_amcs/total/${queryParams ? `?${queryParams?.toString()}` : ''}`
      );

      // if (response?.data?.status === 401) {
      //   authApi.logout();
      // }
      if (response?.data?.status === 401) {
        // authApi.logout();
      }
      if (response?.data?.status === 403) {
        await authApi.refreshToken();
      }

      if (response.data.length > 0) {
        return response.data;
      }
    } catch (error) {
      // If some error occurred while calling api request
      // if user is unauthorized
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return null;
    }
    return null;
  },

  //................... Fetch Total Units Of Order Receive ................................
  async fetchTotalOrdersReceived(filterDate) {
    const instance = getAxios();
    try {
      let queryParams = null;
      if (filterDate) {
        queryParams = new URLSearchParams({ from: filterDate.fromDate, to: filterDate.toDate });
      }
      const response = await instance.get(
        // `${constants.API_BASE_URL + "/api/leads/total"}`
        `${constants.API_BASE_URL}/api/common/orders/total${queryParams ? `?${queryParams?.toString()}` : ''}`
      );

      // if (response.status === 401) {
      //   authApi.logout();
      // }
      if (response?.status === 401) {
        // await authApi.logout();
      }
      if (response?.status === 403) {
        await authApi.refreshToken();
      }

      if (response.data.length > 0) {
        return response.data;
      }
    } catch (error) {
      // If some error occurred while calling api request
      // if user is unauthorized
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return null;
    }
    return null;
  },

  //................... Fetch Total Handovers ................................
  async fetchTotalHandovers(filterDate) {
    const instance = getAxios();
    try {
      let queryParams = null;
      if (filterDate) {
        queryParams = new URLSearchParams({ from: filterDate.fromDate, to: filterDate.toDate });
      }
      const response = await instance.get(
        // `${constants.API_BASE_URL + "/api/leads/total"}`
        `${constants.API_BASE_URL}/api/common/orders/total/handovers${queryParams ? `?${queryParams?.toString()}` : ''}`
      );

      // if (response.status === 401) {
      //   authApi.logout();
      // }
      if (response?.status === 401) {
        // await authApi.logout();
      }
      if (response?.status === 403) {
        await authApi.refreshToken();
      }

      if (response.data.length > 0) {
        return response.data;
      }
    } catch (error) {
      // If some error occurred while calling api request
      // if user is unauthorized
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return null;
    }
    return null;
  },

  //................... Fetch Total warranty due ................................
  async fetchWarrantyDue(filterDate) {

    const instance = getAxios();
    try {
      let queryParams = null;
      if (filterDate) {
        queryParams = new URLSearchParams({ from: filterDate.fromDate, to: filterDate.toDate });
      }
      const response = await instance.get(
        `${constants.API_BASE_URL}/api/common/warranties/due${queryParams ? `?${queryParams?.toString()}` : ''}`
      );

      // if (response.status === 401) {
      //   authApi.logout();
      // }
      if (response?.status === 401) {
        // await authApi.logout();
      }
      if (response?.status === 403) {
        await authApi.refreshToken();
      }

      if (response.data.length > 0) {
        return response.data;
      }
    } catch (error) {
      // If some error occurred while calling api request
      // if user is unauthorized
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return null;
    }
    return null;
  },

  //................... Fetch Total AMC due ................................
  async fetchAMCDue(filterDate) {
    const instance = getAxios();
    try {
      let queryParams = null;
      if (filterDate) {
        queryParams = new URLSearchParams({ from: filterDate.fromDate, to: filterDate.toDate });
      }
      const response = await instance.get(
        `${constants.API_BASE_URL}/api/common/order_amcs/due${queryParams ? `?${queryParams?.toString()}` : ''}`
      );

      // if (response.status === 401) {
      //   authApi.logout();
      // }
      if (response?.status === 401) {
        // await authApi.logout();
      }
      if (response?.status === 403) {
        await authApi.refreshToken();
      }

      if (response.data.length > 0) {
        return response.data;
      }
    } catch (error) {
      // If some error occurred while calling api request
      // if user is unauthorized
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return null;
    }
    return null;
  },

  //................... Fetch Total Units Of Warranty ................................
  async fetchTotalUnitsInWarranty(filterDate) {
    const instance = getAxios();
    try {
      let queryParams = null;
      if (filterDate) {
        queryParams = new URLSearchParams({ from: filterDate.fromDate, to: filterDate.toDate });
      }
      const { data } = await instance.get(
        // `${constants.API_BASE_URL + "/api/leads/total"}`
        `${constants.API_BASE_URL}/api/common/warranties/total${queryParams ? `?${queryParams?.toString()}` : ''}`
      );

      // if (data.status === 401) {
      //   authApi.logout();
      // }
      if (data?.status === 401) {
        // await authApi.logout();
      }
      if (data?.status === 403) {
        await authApi.refreshToken();
      }

      if (data.length > 0) {
        return data;
      }
    } catch (error) {
      // If some error occurred while calling api request
      // if user is unauthorized
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return null;
    }
    return null;
  },

  //................... Fetch All Total Revenue ................................
  async fetchTotalAMCRevenue(filterDate) {
    const instance = getAxios();
    try {
      let queryParams = null;
      if (filterDate) {
        queryParams = new URLSearchParams({ from: filterDate.fromDate, to: filterDate.toDate });
      }
      const { data } = await instance.get(
        `${constants.API_BASE_URL}/api/common/order_amcs/total-revenue${queryParams ? `?${queryParams?.toString()}` : ''}`
      );

      // if (data.status === 401) {
      //   authApi.logout();
      // }
      if (data?.status === 401) {
        // await authApi.logout();
      }
      if (data?.status === 403) {
        await authApi.refreshToken();
      }

      if (data.length > 0) {
        return data;
      }
    } catch (error) {
      // If some error occurred while calling api request
      // if user is unauthorized
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return null;
    }
    return null;
  },

  //................... Fetch All Projects Total Revenue ................................
  async fetchTotalOrderRevenue(filterDate) {
    const instance = getAxios();
    try {
      let queryParams = null;
      if (filterDate) {
        queryParams = new URLSearchParams({ from: filterDate.fromDate, to: filterDate.toDate });
      }
      const response = await instance.get(
        `${constants.API_BASE_URL}/api/common/orders/total-revenue${queryParams ? `?${queryParams?.toString()}` : ''}`
      );

      // if (response.status === 401) {
      //   authApi.logout();
      // }
      if (response?.status === 401) {
        // await authApi.logout();
      }
      if (response?.status === 403) {
        await authApi.refreshToken();
      }

      if (response.data.length > 0) {
        return response.data;
      }
    } catch (error) {
      // If some error occurred while calling api request
      // if user is unauthorized
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return null;
    }
    return null;
  },

  //................... Fetch All Leads For Dashboard ................................
  async fetchLeadForDashboard(filterDate) {
    const instance = getAxios();
    try {
      let queryParams = null;
      if (filterDate) {
        queryParams = new URLSearchParams({ from: filterDate.fromDate, to: filterDate.toDate });
      }
      const response = await instance.get(
        `${constants.API_BASE_URL}/api/common/leads/dashboard${queryParams ? `?${queryParams?.toString()}` : ''}`
      );

      // if (response.status === 401) {
      //   authApi.logout();
      // }
      if (response?.status === 401) {
        // await authApi.logout();
      }
      if (response?.status === 403) {
        await authApi.refreshToken();
      }

      if (response.data.length > 0) {
        return response.data;
      }
    } catch (error) {
      // If some error occurred while calling api request
      // if user is unauthorized
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return null;
    }
    return null;
  },

  //................... Fetch All leads Not Converted ................................
  async fetchLeadNotConverted(filterDate) {
    const instance = getAxios();
    try {
      let queryParams = null;
      if (filterDate) {
        queryParams = new URLSearchParams({ from: filterDate.fromDate, to: filterDate.toDate });
      }
      const response = await instance.get(
        `${constants.API_BASE_URL}/api/common/leads/close-converted${queryParams ? `?${queryParams?.toString()}` : ''}`
      );

      // if (response.status === 401) {
      //   authApi.logout();
      // }
      if (response?.status === 401) {
        // await authApi.logout();
      }
      if (response?.status === 403) {
        await authApi.refreshToken();
      }

      if (response.data.length > 0) {
        return response.data;
      }
    } catch (error) {
      // If some error occurred while calling api request
      // if user is unauthorized
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return null;
    }
    return null;
  },

  //.... Fetch All Warranty ..........
  async fetchUpcomingWarranties() {
    // Get axios Instance
    const instance = getAxios();
    try {
      // Called the API
      const response = await instance.get(
        `${constants.API_BASE_URL + "/api/common/warranties/upcoming"}`
      );

      // console.log("response", response);

      // If records found
      if (response?.data.length > 0) {
        // console.log("data", response?.data);
        return response?.data;
      }
    } catch (error) {
      // If some error occurred while calling api request
      // if user is unauthorized
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return null;
    }

    return null;
  },

  //................... Fetch All Orders (For DashBoard Graph) ................................
  async fetchOrderForDashboard(filterDate) {
    const instance = getAxios();
    try {
      let queryParams = null;
      if (filterDate) {
        queryParams = new URLSearchParams({ from: filterDate.fromDate, to: filterDate.toDate });
      }
      const response = await instance.get(
        `${constants.API_BASE_URL}/api/common/orders/dashboard${queryParams ? `?${queryParams?.toString()}` : ''}`
      );

      // if (response.status === 401) {
      //   authApi.logout();
      // }
      if (response?.status === 401) {
        // await authApi.logout();  
      }
      if (response?.status === 403) {
        await authApi.refreshToken();
      }

      if (response.data.length > 0) {
        return response.data;
      }
    } catch (error) {
      // If some error occurred while calling api request
      // if user is unauthorized
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return null;
    }
    return null;
  },

  //................... Fetch All Orders AMC (For DashBoard Graph) ................................
  async fetchOrderAMCForDashboard(filterDate) {
    const instance = getAxios();
    try {
      let queryParams = null;
      if (filterDate) {
        queryParams = new URLSearchParams({ from: filterDate.fromDate, to: filterDate.toDate });
      }
      const response = await instance.get(
        `${constants.API_BASE_URL}/api/common/order_amcs/dashboard${queryParams ? `?${queryParams?.toString()}` : ''}`
      );

      // if (response.status === 401) {
      //   authApi.logout();
      // }
      if (response?.status === 401) {
        // await authApi.logout();
      }
      if (response?.status === 403) {
        await authApi.refreshToken();
      }

      if (response.data.length > 0) {
        return response.data;
      }
    } catch (error) {
      // If some error occurred while calling api request
      // if user is unauthorized
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return null;
    }
    return null;
  },
  // ******************************* Payments ******************************************

  // ................... Create Payments ................................
  async createPayment(payments) {
    // Get axios instance
    const instance = getAxios();
    try {
      // Call the API
      const response = await instance.post(
        `${constants.API_BASE_URL}/api/payments/`,
        payments
      );
      // If payment created successfully
      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      // If an error occurs
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.error("Error creating payment:", error.response);
    }
    return null;
  },

  // ................... Save Payments ................................
  async savePayment(payments) {
    // Get axios instance
    const instance = getAxios();
    try {
      // Call the API
      const response = await instance.put(
        `${constants.API_BASE_URL}/api/payments/${payments.id}`,
        payments
      );
      // If payment saved successfully
      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      // If an error occurs
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.error("Error saving payment:", error.response);
    }
    return null;
  },

  // ................... Fetch All Payments ................................
  async fetchPayments(id) {
    // Get axios instance
    const instance = getAxios();
    try {
      // Call the API
      const response = await instance.get(
        `${constants.API_BASE_URL}/api/payments/parent/${id}`
      );
      // If unauthorized, logout
      // if (response?.data?.status === 401) {
      //   authApi.logout();
      // }
      if (response?.data?.status === 401) {
        // authApi.logout();
      }
      if (response?.data?.status === 403) {
        await authApi.refreshToken();
      }
      // Return payments data if available
      if (response?.data?.length > 0) {
        return response?.data;
      }
    } catch (error) {
      console.error("Error fetching payments:", error.response);
    }
    return null;
  },

  // ................... Fetch All Payments (Order Wise) ................................
  async fetchOrderWisePayments(id) {
    // Get axios instance
    const instance = getAxios();
    try {
      // Call the API
      const response = await instance.get(
        `${constants.API_BASE_URL}/api/orders/payments/${id}`
      );
      // if (response?.data?.status === 401) {
      //   authApi.logout();
      // }
      if (response?.data?.status === 401) {
        // authApi.logout();
      }
      if (response?.data?.status === 403) {
        await authApi.refreshToken();
      }
      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      console.error("Error fetching project payments:", error.response);
    }
    return null;
  },

  // ................... Fetch All Payments (Project Wise to show On Lead Page) ................................
  async fetchProjectPaymentsLeads(id) {
    // Get axios instance
    const instance = getAxios();
    try {
      // Call the API
      const response = await instance.get(
        `${constants.API_BASE_URL}/api/orders/payments/leads/${id}`
      );
      // if (response?.data?.status === 401) {
      //   authApi.logout();
      // }
      if (response?.data?.status === 401) {
        // await authApi.logout();
      }
      if (response?.data?.status === 403) {
        await authApi.refreshToken();
      }
      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      console.error(
        "Error fetching project payments for leads:",
        error.response
      );
    }
    return null;
  },

  // ................... Fetch Project Total Amount (Lead Page) ................................
  async fetchProjectTotalAmountLeads(id) {
    // Get axios instance
    const instance = getAxios();
    try {
      // Call the API
      const response = await instance.get(
        `${constants.API_BASE_URL}/api/orders/pay/leads/${id}`
      );
      // if (response?.data?.status === 401) {
      //   authApi.logout();
      // }

      if (response?.data?.status === 401) {
        // authApi.logout();  
      }
      if (response?.data?.status === 403) {
        await authApi.refreshToken();
      }

      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      console.error(
        "Error fetching project total amount for leads:",
        error.response
      );
    }
    return null;
  },

  // .............. Fetch Payment By Id .............................
  async fetchPaymentById(id) {
    // Get axios instance
    const instance = getAxios();
    try {
      // Call the API
      const response = await instance.get(
        `${constants.API_BASE_URL}/api/payments/${id}`
      );
      // if (response?.data?.status === 401) {
      //   authApi.logout();
      // }
      if (response?.data?.status === 401) {
        // authApi.logout();
      }
      if (response?.data?.status === 403) {
        await authApi.refreshToken();
      }

      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      console.error("Error fetching payment by ID:", error.response);
    }
    return null;
  },

  // .......... Delete Payments .............................
  async deletePayment(id) {
    // Get axios instance
    const instance = getAxios();
    try {
      // Call the API
      const response = await instance.delete(
        `${constants.API_BASE_URL}/api/payments/${id}`
      );
      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      // If unauthorized, logout
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.error("Error deleting payment:", error.response);
    }
    return null;
  },

  //................... Create Backup ................................
  async createBackup(lead) {
    const token = localStorage.getItem("token");

    let response = await fetch(constants.API_BASE_URL + "/api/backup", {
      method: "POST",
      mode: "cors",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
      body: JSON.stringify(lead),
    });
    return await response.json();
  },

  //................... Fetch Backup ................................
  async fetchBackups() {
    const token = localStorage.getItem("token");
    let response = await fetch(constants.API_BASE_URL + "/api/backup", {
      method: "GET",
      mode: "cors",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    });

    // if (response.status === 401) {
    //   authApi.logout();
    // }
    if (response?.status === 401) {
      // await authApi.logout();
    }
    if (response?.status === 403) {
      await authApi.refreshToken();
    }
    const result = await response.json();
    if (result.length > 0) {
      return result;
    }
    return null;
  },

  //...................  Download Backup ................................
  async downloadBackupFile(filename) {
    const token = localStorage.getItem("token");
    let response = await fetch(
      constants.API_BASE_URL + "/api/backup/download/" + filename,
      {
        method: "GET",
        //mode: "cors",

        headers: {
          Authorization: token,
        },
      }
    );
    const fileBody = await response.blob();
    return fileBody;
  },

  //...................  Delete Backup ................................
  async deleteBackupFile(filename) {
    const instance = getAxios();
    const { data } = await instance.delete(
      `${constants.API_BASE_URL + "/api/backup/delete/" + filename}`
    );
    if (data.length > 0) {
      return data;
    }
    return null;
  },

  // ************** Utils  ********************************** 
  //................... For CSV upload................................
  async uploadCSVFile(formData, targetedEndpoint) {
    const token = localStorage.getItem("token");
    try {
      if (targetedEndpoint) {

        const response = await fetch(`${constants.API_BASE_URL}/api/${targetedEndpoint}/upload`, {
          method: "POST",
          headers: {
            Authorization: token,
          },
          body: formData,
        });

        console.log('response', response);
        if (response.status == 201) {
          const result = await response.json();
          console.log('result', result);
          return result;
        }
        throw response;
      } else {
        throw new Error('Endpoint not found')
      }
    } catch (error) {
      // If some error occurred while calling api request
      // if user is unauthorized
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      const response = await error.json();
      // console.log('error response',response);
      return { errors: response.errors };
    }

    return null;
  },

  //Phase-2 Point

  async fetchAllFilterRecords(Data) {//For Lead Filter
    const instance = getAxios();
    //console.log(instance)
    const response = await instance.get(
      `${constants.API_BASE_URL + "/api/common/filters"}`, { params: Data, }
    );
    console.log(response, "test");
    // if (response.status === 401) {
    //   authApi.logout();
    // }
    if (response?.status === 401) {
      // await authApi.logout();
    }
    if (response?.status === 403) {
      await authApi.refreshToken();
    }

    if (response.data && Array.isArray(response.data)) {
      return response.data;
    }
    return null;
  },

  async fetchAllFilterRecordsSiteVisit(Data) {//For Site Visit Filter
    const instance = getAxios();
    //console.log(instance)
    const response = await instance.get(
      `${constants.API_BASE_URL + "/api/common/filters/site"}`, { params: Data, }
    );
    // console.log(response, "test");
    // if (response.status === 401) {
    //   authApi.logout();
    // }
    if (response?.status === 401) {
      // await authApi.logout();  
    }
    if (response?.status === 403) {
      await authApi.refreshToken();
    }

    if (response.data && Array.isArray(response.data)) {
      return response.data;
    }
    return null;
  },

  async fetchAllFilterRecordsOffer(Data) {//For Offer Filter
    const instance = getAxios();
    //console.log(instance)
    const response = await instance.get(
      `${constants.API_BASE_URL + "/api/common/filters/offer"}`, { params: Data, }
    );
    // console.log(response, "test");
    // if (response.status === 401) {
    //   authApi.logout();
    // }
    if (response?.status === 401) {
      // await authApi.logout();
    }
    if (response?.status === 403) {
      await authApi.refreshToken();
    }

    if (response.data && Array.isArray(response.data)) {
      return response.data;
    }
    return null;
  },

  async fetchAllFilterRecordsOrder(Data) {//For Order Filter
    const instance = getAxios();
    //console.log(instance)
    const response = await instance.get(
      `${constants.API_BASE_URL + "/api/common/filters/order"}`, { params: Data, }
    );
    // console.log(response, "test");
    // if (response.status === 401) {
    //   authApi.logout();
    // }
    if (response?.status === 401) {
      // await authApi.logout();
    }
    if (response?.status === 403) {
      await authApi.refreshToken();
    }

    if (response.data && Array.isArray(response.data)) {
      return response.data;
    }
    return null;
  },

  async fetchAllFilterRecordsWarrenty(Data) {//For Warrenty Filter
    const instance = getAxios();
    //console.log(instance)
    const response = await instance.get(
      `${constants.API_BASE_URL + "/api/common/filters/warrenty"}`, { params: Data, }
    );
    console.log(response, "test");
    // if (response.status === 401) {
    //   authApi.logout();
    // }
    if (response?.status === 401) {
      // await authApi.logout();
    }
    if (response?.status === 403) {
      await authApi.refreshToken();
    }

    if (response.data && Array.isArray(response.data)) {
      return response.data;
    }
    return null;
  },

  async fetchAllFilterRecordsAMC(Data) {//For AMC Filter
    const instance = getAxios();
    //console.log(instance)
    const response = await instance.get(
      `${constants.API_BASE_URL + "/api/common/filters/amc"}`, { params: Data, }
    );
    // console.log(response, "test");
    // if (response.status === 401) {
    //   authApi.logout();
    // }
    if (response?.status === 401) {
      // await authApi.logout();
    }
    if (response?.status === 403) {
      await authApi.refreshToken();
    }

    if (response.data && Array.isArray(response.data)) {
      return response.data;
    }
    return null;
  },



  // ************************ Commission ****************************
  //.... Create Commission .........
  async createCommission(commissions) {
    // Get axios Instance
    const instance = getAxios();
    try {
      // Called the API
      const response = await instance.post(
        `${constants.API_BASE_URL + "/api/commissions/"}`,
        commissions
      );
      // console.log("response", response);
      // If record created
      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      // If some error occurred while calling api request
      // if user is unauthorized
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return { errors: error?.response?.data?.errors };
    }

    return null;
  },

  //.... Fetch All Commission ..........
  async fetchCommissions() {
    // Get axios Instance
    const instance = getAxios();
    try {
      // Called the API
      const response = await instance.get(
        `${constants.API_BASE_URL + "/api/commissions/"}`
      );

      // console.log("response", response);

      // If records found
      if (response?.data.length > 0) {
        // console.log("data", response?.data);
        return response?.data;
      }
    } catch (error) {
      // If some error occurred while calling api request
      // if user is unauthorized
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      // console.log(error.response);
      return null;
    }

    return null;
  },

  //..... Fetch Commission By Id ...........
  async fetchCommissionById(id) {
    // Get axios Instance
    const instance = getAxios();
    try {
      // Called the API
      const response = await instance.get(
        `${constants.API_BASE_URL + "/api/commissions/" + id}`
      );

      // If record found
      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      // If some error occurred while calling api request
      // if user is unauthorized
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return null;
    }
    return null;
  },

  // ....Update Commission.........
  async saveCommission(commissions) {
    // Get axios Instance
    const instance = getAxios();
    try {
      // Called the API
      const response = await instance.put(
        `${constants.API_BASE_URL + "/api/commissions/" + commissions.id}`,
        commissions
      );

      // If record found
      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      // If some error occurred while calling api request
      // if user is unauthorized
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return { errors: error?.response?.data?.errors };
    }
    return null;
  },

  //...... Delete Commission .............................
  async deleteCommission(id) {
    // Get axios Instance
    const instance = getAxios();
    try {
      // Called the API
      const response = await instance.delete(
        `${constants.API_BASE_URL + "/api/commissions/" + id}`
      );
      // If record deleted successfully
      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      // If some error occurred while calling api request
      // if user is unauthorized
      if (error?.response?.status === 401) {
        // await authApi.logout();
      }
      if (error?.response?.status === 403) {
        await authApi.refreshToken();
      }
      console.log(error.response);
      return null;
    }
    return null;
  },

  // ************************ Contact End Here ***********************************

  // -------------------------------Pulse Dashboard -----------------------------------------------


  /**
 * @author      Rahul Joshi
 * @date        October,06,2025
 * @copyright   www.ibirdsservices.com
 * @description API to login into Superset and return login data ("access_token" , "refresh_token")
 * @returns {Object} Superset Login Data
 */
  /**
    * @author      Rahul Joshi
    * @date        October,06,2025
    * @copyright   www.ibirdsservices.com
    * @description API to login into Superset and return login data ("access_token" , "refresh_token")
    * @returns {Object} Superset Login Data
    */
  async supersetLogin() {
    try {
      const token = localStorage.getItem("token");
      const response = await fetch(
        constants.API_BASE_URL + "/api/supersetapi/login",
        {
          method: "POST",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        }
      );
      const logindata = await response.json();
      // console.log("loginData ", logindata);
      return logindata;
    } catch (error) {
      console.error("Error during Superset login:", error);
      throw error;
    }
  },


  /**
   * @author      Rahul Joshi
   * @date        October, 13, 2025
   * @copyright   www.ibirdsservices.com
   * @description Generate a Superset guest token for a given user and dashboard.
   *              The backend route `/generate-token` sets first_name, last_name, and roles using environment variables.
   * @param {string} access_token - Superset access token obtained from login.
   * @param {string} UUID - UUID of the dashboard to embed.
   * @param {Object} user - User object containing email.
   * @returns {string} guestToken - Superset guest token for embedding dashboard.
   */
  async guestToken(access_token, UUID, userEmail) {
    try {
      // Only sending minimal required info; backend fills in names and roles
      const guestTokenBody = {
        access_token: access_token,
        dashboard_id: UUID,
      };
      // Add 'user' object only if username exists
      if (userEmail) {
        guestTokenBody.user = { username: userEmail };
      }
      console.log("Guest token request body:", guestTokenBody);
      let token = localStorage.getItem("token");
      const response = await fetch(
        constants.API_BASE_URL + "/api/supersetapi/generate-token",
        {
          method: "POST",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
          body: JSON.stringify(guestTokenBody),
        }
      );
      const guestData = await response.json();
      // console.log("guestData  ", guestData);
      return guestData;
    } catch (error) {
      console.error("Error generating Superset guest token:", error);
      throw error;
    }
  },

  // End Here Pulse Dashboard

  // ************************ SPECIFICATION ****************************
  async createSpecification(data) {
    const instance = getAxios();
    try {
      const response = await instance.post(`${constants.API_BASE_URL}/api/specification/`, data);
      return response?.data;
    } catch (error) {
      return null;
    }
  },
  async fetchSpecifications() {
    const instance = getAxios();
    try {
      const response = await instance.get(`${constants.API_BASE_URL}/api/specification/`);
      return response?.data;
    } catch (error) {
      return [];
    }
  },
  async updateSpecification(data) {
    const instance = getAxios();
    try {
      const response = await instance.put(`${constants.API_BASE_URL}/api/specification/${data.id}`, data);
      return response?.data;
    } catch (error) {
      return null;
    }
  },

  // ************************ CATEGORY MODULE (CLONE) ****************************
  async createCategory(data) {
    const instance = getAxios();
    try {
      const response = await instance.post(`${constants.API_BASE_URL}/api/category/`, data);
      return response?.data;
    } catch (error) {
      return null;
    }
  },
  async getCategoryList() {
    const instance = getAxios();
    try {
      const response = await instance.get(`${constants.API_BASE_URL}/api/category/`);
      return response?.data;
    } catch (error) {
      return [];
    }
  },
  async getCategoryById(id) {
    const instance = getAxios();
    try {
      const response = await instance.get(`${constants.API_BASE_URL}/api/category/${id}`);
      return response?.data;
    } catch (error) {
      return null;
    }
  },
  async updateCategory(data) {
    const instance = getAxios();
    try {
      const response = await instance.put(`${constants.API_BASE_URL}/api/category/${data.id}`, data);
      return response?.data;
    } catch (error) {
      return null;
    }
  },

  // Fallback alias for Product Form dependency if needed
  async fetchCategories() {
    return await this.getCategoryList();
  },

};

export default solisPowerApi;
